import { Alert, AlertTitle, type SxProps, type Theme } from "@mui/material";

type Props = {
  title: string;
  message: string;
  isExpired: boolean;
  sx?: SxProps<Theme>;
};

export const ExpirationAlert = ({ title, message, isExpired, sx }: Props) => (
  <Alert severity={isExpired ? "error" : "warning"} sx={sx}>
    <AlertTitle>{title}</AlertTitle>
    {message}
  </Alert>
);
